import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { isEqual, sortBy } from 'lodash';
import { stripesConnect } from '@folio/stripes-core';
import DashboardsContext from './DashboardsContext';

function DashboardsProvider(props) {
  const [dashboards, setDashboards] = useState([]);

  useEffect(() => {
    const dashboardsList = sortBy(
      (props.resources.dashboards || {}).records || [],
      ['displayOrder', 'id']
    );
    if (!isEqual(dashboardsList, dashboards)) {
      setDashboards(dashboardsList);
    }
  }, [dashboards, props.resources.dashboards]);

  return (
    <DashboardsContext.Provider value={dashboards}>
      {props.children}
    </DashboardsContext.Provider>
  );
}

DashboardsProvider.propTypes = {
  children: PropTypes.node,
  resources: PropTypes.shape({
    dashboards: PropTypes.shape({
      records: PropTypes.arrayOf(PropTypes.object),
    }),
  }),
};

DashboardsProvider.manifest = {
  dashboards: {
    type: 'okapi',
    records: 'dashboards',
    path: 'dashboards?limit=1000',
    fetch: (props) => props.stripes.hasPerm('ui-reports.dashboards.view'),
  },
};

export default stripesConnect(DashboardsProvider);
